import { CfarService } from "../service/asyncBatchCfarService";
import * as validations from "../utils/validations";

export class CfarFunctions {
  fnBurgissCalcCFaR(
    investId?: any[][],
    idType?: string,
    analysisDate?: any,
    currency?: any,
    selectionSetID?: any,
    filter?: any,
    horizonQtrs?: any,
    sampleStatistic?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    minSampleSize?: any,
    maxDroppedPeriods?: any,
    bMUWindowEndDate?: any,
    bMUHistoricalWindowLengthQtrs?: any,
    maxAgeDiffYears?: any,
    stopOn?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);

    if (investId.toString() == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }

    idType = validations.getIdType(idType);
    if (idType.toString() == "404") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }

    selectionSetID = validations.isValidSelectionId(selectionSetID);
    if (selectionSetID == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    const baselocalcurrencyparamResult: string = validations.validateBaseLocalCurrencyParam(currency, "Holding");
    if (baselocalcurrencyparamResult == "Invalid" || baselocalcurrencyparamResult == "false") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    const alternatebasecurrrency: string = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternatebasecurrrency.toString().includes("InvError")) {
      return alternatebasecurrrency.toString().replace("InvError ", "");
    }

    analysisDate = validations.isValidDate(analysisDate);
    analysisDate = new Date(analysisDate).toLocaleDateString();
    if (analysisDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid Analysis Date parameter";
    }

    let validBMUEndQuarter: any = null;

    if (bMUWindowEndDate == "" || bMUWindowEndDate == null) {
      validBMUEndQuarter = validations.bmuendquarterDate();
    } else {
      bMUWindowEndDate = validations.isValidDate(bMUWindowEndDate);
      const dBMUendQuarterDate: boolean = validations.searchedDateInMeasurementDate(bMUWindowEndDate, "E");
      if (dBMUendQuarterDate == true) {
        validBMUEndQuarter = bMUWindowEndDate;
      }
    }

    if (validBMUEndQuarter.year == 1 || validBMUEndQuarter == new Date(0)) {
      return "#INVALIDPARAMETERS - Invalid BMU Window End Date parameter";
    }

    bMUHistoricalWindowLengthQtrs = validations.validBMUHistoricalWindowLengthQtrs(bMUHistoricalWindowLengthQtrs);
    if (bMUHistoricalWindowLengthQtrs.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + bMUHistoricalWindowLengthQtrs.toString().replace("Error", "");
    }

    horizonQtrs = validations.validHorizonQuarter(horizonQtrs);
    if (horizonQtrs.toString().includes("Error")) {
      return "#INVALIDPARAMETERS -" + horizonQtrs.toString().replace("Error", "");
    }

    sampleStatistic = validations.valSampleStatistics(sampleStatistic);
    if (sampleStatistic.toString().includes("Error")) {
      return "#INVALIDPARAMETERS -" + sampleStatistic.toString().replace("Error", "");
    }

    numSimulations = validations.validNumsimulation(numSimulations);
    if (numSimulations.toString().includes("Error")) {
      return "#INVALIDPARAMETERS -" + numSimulations.toString().replace("Error", "");
    }

    desiredSampleSize = validations.validDesiredSampleSize(desiredSampleSize);
    if (desiredSampleSize.toString().includes("Error")) {
      return "#INVALIDPARAMETERS -" + desiredSampleSize.toString().replace("Error", "");
    }

    minSampleSize = validations.validMinsamplesize(minSampleSize);
    if (minSampleSize.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + minSampleSize.toString().replace("Error", "");
    }

    maxDroppedPeriods = validations.valMaxdroppedperiodact(maxDroppedPeriods);
    if (maxDroppedPeriods.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + maxDroppedPeriods.toString().replace("Error", "");
    }

    maxAgeDiffYears = validations.validMaxAgeDiffYears(maxAgeDiffYears);
    if (maxAgeDiffYears.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + maxAgeDiffYears.toString().replace("Error", "");
    }

    stopOn = validations.validStopOn(stopOn);
    if (stopOn.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + stopOn.toString().replace("Error", "");
    }
    return new CfarService().BurgissCalcCFaR(
      investId,
      idType,
      analysisDate,
      baselocalcurrencyparamResult,
      selectionSetID,
      filter,
      horizonQtrs,
      sampleStatistic,
      numSimulations,
      desiredSampleSize,
      minSampleSize,
      maxDroppedPeriods,
      validBMUEndQuarter,
      bMUHistoricalWindowLengthQtrs,
      maxAgeDiffYears,
      stopOn,
      alternatebasecurrrency,
      uniqueCellId
    );
  }
}
